export enum CourseStatus {
    Fail = 100,
    Pass = 200,
    Expired = 300
}